// DS: B19.3
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, {
  Props as ButtonProps,
} from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

import s from './HeroEditSecondaryButton.scss';

export interface Props extends ButtonProps {}

export const HeroEditSecondaryButton: React.FC<Props> = ({
  className,
  ...props
}) => (
  <PlainButtonOrLink className={classnames(s['root'], className)} {...props} />
);

HeroEditSecondaryButton.displayName = 'HeroEditSecondaryButton';

export default HeroEditSecondaryButton;
